import ImageCarousel from '~/components/ImageCarousel';
import { ImageCarouselInterface, Media } from '~/payload-types';

type Props = ImageCarouselInterface & {};

export const ImageCarouselBlock: React.FC<Props> = (props) => {
  const { images } = props;

  if (!images || images.length === 0) {
    return null;
  }

  let medias = images
    .map((image) => image.image)
    .filter((image) => image != null) as any as Media[];

  if (medias.length === 0) {
    return null;
  }

  return (
    <ImageCarousel
      images={medias.map((image) => {
        return {
          src: image.url!,
          width: image.width!,
          height: image.height!,
        };
      })}
    />
  );
};
